<template>
  <div class="index bg-white pad12-t">
    <!-- 身份切换 -->
    <div class="pad12-lr">
      <div class="flex ent-switch" @click="chooseEntShow = true" v-if="defaultEnt.ID">
        <img v-if="defaultEnt.Logo" class="w32 h100-full radius5" :src="defaultEnt.Logo" />
        <img v-else class="w32 h100-full radius5" src="./images/ent-icon.png" />
        <div class="pad10-l flex-auto flex flex-column justify-center">
          <div class="flex items-center">
            <span class="f13 fb text-overflow">{{ defaultEnt.Name }}</span>
            <img class="mar5-l w12 flex-shrink" src="./images/ent-choose.png" />
          </div>
          <span class="f10 gray6">{{ defaultEnt.phone }}</span>
        </div>
      </div>
      <div class="flex items-center" v-else>
        <img class="w32 h100-full" src="@/assets/images/user.png" />
        <div class="pad10-l" @click="toLogin">立即登录</div>
      </div>
    </div>
    <!-- search -->
    <van-sticky>
      <div class="pad12 bg-white" @click="routerClick('vm2/search/search', 'sc')">
        <Search :text="searchText" />
      </div>
    </van-sticky>
    <!-- guide -->
    <div class="pad12-b pad12-lr guide">
      <ul class="flex items-center justify-between">
        <li
          class="flex flex-column items-center justify-center relative"
          v-for="item in guide"
          :key="item.name"
          @click="routerClick(item.url, item.type, item.isLogin)"
        >
          <span class="white f10 radius30 absolute mark" v-if="countCart && item.isMark">{{
            countCart
          }}</span>
          <img :src="item.icon" />
          <span class="f12">{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <!-- swipe -->
    <div class="pad12-b pad12-lr swipe">
      <van-swipe :autoplay="3000" lazy-render>
        <van-swipe-item
          v-for="(item, index) in swipeList"
          :key="index"
          @click="routerClick(item.url, 'link')"
        >
          <van-image lazy-load :src="`${item.img}?imageView2/1/w/700/h/280`" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- headline -->
    <div class="pad12-b pad12-lr">
      <div class="pad12-lr radius5 headline flex items-center">
        <img src="./images/headline.png" />
        <van-swipe :autoplay="3000" vertical :show-indicators="false">
          <van-swipe-item
            class="text-overflow"
            v-for="(item, index) in headline"
            :key="index"
            @click="routerClick(item.topUrl, 'link')"
          >
            {{ item.topContent }}
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- classify -->
    <div class="pad12-b classify">
      <ul class="flex flex-wrap">
        <li
          class="pad10-b flex flex-column items-center justify-center"
          v-for="(item, index) in classify"
          :key="index"
          @click="routerClick(item.iconLink, 'link')"
        >
          <img :src="item.iconImg" />
          <span class="f12 gray3 mar5-t">{{ item.iconName }}</span>
        </li>
      </ul>
    </div>
    <!-- 货联 -->
    <!-- <div class="pad8-b pad12-lr flex justify-between">
      <img class="w178" @click="routerClick('mob/huo/index.html', 'hl')" src="./images/car.png" />
      <img class="w178" @click="routerClick('mob/che/index.html', 'hl')" src="./images/cargo.png" />
    </div> -->
    <!-- channel -->
    <div class="pad12-lr pad12-b channel">
      <ul class="flex flex-wrap">
        <li v-for="item in channel" :key="item.name" @click="routerClick(item.url)">
          <img class="w100-full radius5" :src="item.img" />
        </li>
      </ul>
    </div>
    <!-- 直播 -->
    <div class="pad12-lr pad12-b live" v-if="liveList.length">
      <div class="flex items-center">
        <img class="h15" src="./images/living-title.png" />
        <img class="w32" src="./images/living-icon.gif" />
      </div>
      <div class="live-list mar5-t radius5 flex items-center">
        <ul class="overflow-auto">
          <li
            v-for="(item, index) in liveList"
            :key="index"
            @click="routerClick(item.shareContent, 'link')"
          >
            <img class="radius5" :src="`${item.mobBannerPic}?imageView2/1/w/400/h/230`" />
          </li>
          <li class="radius5 bg-white">
            <img class="radius5" src="./images/live-more.png" />
          </li>
        </ul>
      </div>
    </div>
    <!-- yyzx -->
    <div class="pad12-lr pad12-b" v-if="yyzx.shopName">
      <div class="activity pad15-lr pad20-t">
        <ul class="flex justify-between mar10-b">
          <li
            class="flex flex-column bg-white radius5"
            v-for="item in yyzx.goodList"
            :key="item.goodsId"
            @click="routerClick(`/goodDetails/${item.goodsId}`)"
          >
            <img :src="item.imgUrl" />
            <div class="pad5">
              <p class="lin-20 f12 fb gray3 text-overflow mar5-b">{{ item.goodsName }}</p>
              <p class="red">¥{{ item.sellFactPriceStr }}</p>
              <!-- <p class="f11 gray9">206人看过</p> -->
            </div>
          </li>
        </ul>
        <div class="f16 red fb pad20-lr text-center lin-35 text-overflow">{{ yyzx.shopName }}</div>
      </div>
    </div>
    <!-- recommend v-if="userInfo.id" -->
    <div class="pad12-lr bg-grayf2 recommend">
      <div class="flex items-center">
        <div class="flex-shrink f18 pad10-r gray3 fb">{{ recommend.name }}</div>
        <ul class="flex-auto floor-list">
          <li
            class="pad10-lr pad5-tb f15 gray9 relative"
            :class="{ active: item.id === recommendId }"
            v-for="item in recommend.floorList"
            :key="item.id"
            @click="recommendChoose(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <!-- 优品 -->
      <template v-if="recommendId === 'good' && recommendGood.length">
        <GoodList :goodsList="recommendGood" @getCountCart="getCountCart" />
      </template>
      <!-- 好店 -->
      <template v-if="recommendId === 'shop' && recommendShop.length">
        <ShopList :shopList="recommendShop" />
      </template>
    </div>
    <!-- 活动 -->
    <template v-for="(item, index) in floorList">
      <div class="pad12 bg-grayf2 min-300" :key="index" v-if="floorList.length">
        <div class="flex items-center">
          <div class="flex-shrink f18 pad10-r gray3 fb">{{ item.name }}</div>
          <ul class="flex-auto floor-list" v-if="item.subFloorList">
            <li
              class="pad10-lr pad5-tb inline-block f15 gray9 relative"
              :class="{ active: item.subIndex === index1 }"
              v-for="(sub, index1) in item.subFloorList"
              :key="index1"
              @click="chooseSub(sub, index, index1)"
            >
              {{ sub.name }}
            </li>
          </ul>
        </div>
        <template
          v-if="
            item.subFloorList &&
              item.subFloorList[item.subIndex].goodList &&
              item.subFloorList[item.subIndex].goodList.length
          "
        >
          <GoodList
            v-if="floorType === '0'"
            :goodsList="item.subFloorList[item.subIndex].goodList"
            @getCountCart="getCountCart"
          />
          <ShopList v-else :shopList="item.subFloorList[item.subIndex].goodList" />
        </template>
        <template v-if="!item.subFloorList && item.goodList && item.goodList.length">
          <GoodList
            v-if="floorType === '0'"
            :goodsList="item.goodList"
            @getCountCart="getCountCart"
          />
          <ShopList v-else :shopList="item.goodList" />
        </template>
        <van-loading v-if="item.loading" size="20px" class="text-center pad50-t"
          >加载中...</van-loading
        >
      </div>
    </template>

    <div class="footer_iphone bg-grayf2"></div>
    <!-- 购物车悬浮图标 -->
    <div class="shop-cart text-right pad5-t pad5-r" @click="routerClick('/cart', '', 1)">
      <span class="white f10 radius30" v-if="countCart">{{ countCart }}</span>
    </div>
    <!-- 身份切换弹窗 -->
    <!-- eslint-disable-next-line -->
    <van-popup v-model:show="chooseEntShow" position="left">
      <div class="pad15 flex flex-column h100-full ent-list">
        <div class="flex h60">
          <img v-if="defaultEnt.Logo" class="w60 h100-full radius10" :src="defaultEnt.Logo" />
          <img v-else class="w60 h100-full radius10" src="./images/ent-icon.png" />
          <div class="pad10-l flex-auto flex flex-column justify-between">
            <div>
              <span class="fb"> {{ defaultEnt.Name }} </span>
              <span class="user-tag mar5-l f10 flex-shrink" v-if="defaultEnt.isUser">个人</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="f12 gray6">{{ defaultEnt.phone }}</span>
              <!-- ${VUE_APP_M}user/edit -->
              <div
                class="pad20-l flex items-center"
                @click="routerClick(`${origin.VUE_APP_M}user/edit`, 'link')"
              >
                <img class="w20" src="./images/ent-user.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="pad10-t pad15-b">
          <van-search v-model="entSearch" placeholder="搜索企业" @input="entListUpdate" />
        </div>
        <div class="f15 gray6 fb">企业选择</div>
        <div class="flex-auto overflow-auto">
          <ul>
            <li
              class="lin-15 flex items-center justify-between"
              v-for="item in entList"
              :key="item.ID"
              @click="updateEnterprise(item.ID)"
            >
              <span class="f13 gray9 flex flex-auto pad10-r">
                <span
                  class="ellipsis flex-auto lin-20"
                  :class="{ active: item.ID === defaultEnt.ID }"
                >
                  {{ item.Name }}
                  <span class="user-tag mar5-l f10 flex-shrink" v-if="item.isUser">个人</span>
                </span>
              </span>
              <span class="current-tag f10 flex-shrink" v-if="item.ID === defaultEnt.ID">当前</span>
              <span class="choose-tag f10 flex-shrink" v-else>选择</span>
            </li>
          </ul>
        </div>
        <div class="pad15-t">
          <div @click="routerClick('logout.do', 'sc')">
            <img class="w20 mar5-r" src="./images/logout.png" />
            <span>退出登录</span>
          </div>
        </div>
        <div class="safe-area-inset-bottom"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import jsonp from "jsonp";
import { Toast } from "vant";
import { mapState } from "vuex";
import Search from "@/components/search";
import common from "../../assets/js/common";
import GoodList from "./components/goodList";
import ShopList from "./components/shopList";

export default {
  components: {
    Search,
    GoodList,
    ShopList
  },
  data() {
    return {
      searchText: "请输入货品名称",
      origin: process.env,
      countCart: 0,
      entList: [],
      entAllList: [],
      defaultEnt: {},
      entSearch: "",
      chooseEntShow: false, // 是否显示切换企业
      swipeList: [], // 广告轮播图列表
      headline: [], // 商城头条
      classify: [], // 分类导航
      guide: [
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/index/guide/OftenBuy.png",
          name: "常购",
          url: "mob/recommend/page.do?isSCIndex=1&from=znt",
          type: "sc",
          isLogin: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/index/guide/classify.png",
          name: "分类",
          url: "/categories",
          type: "",
          isLogin: false
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/index/guide/collect.png",
          name: "收藏",
          url: "mob/member/favorite/listPage.do?type=1",
          type: "sc",
          isLogin: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/index/guide/coupon.png",
          name: "优惠券",
          url: "cashCoupon/mob/toPage",
          type: "sc",
          isLogin: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/index/guide/cart.png",
          name: "购物车",
          url: "/cart",
          type: "",
          isLogin: true,
          isMark: true
        },
        {
          icon: "https://cmscenter-files.nxin.com/nxsc/index/guide/my.png",
          name: "我的商城",
          url: "mob/memberInfo/list?typeId=4",
          type: "sc",
          isLogin: true
        }
      ],
      channel: [
        {
          img: "https://cmscenter-files.nxin.com/nxsc/index/channel/channel-ent.png",
          url: "/channel/shop?shopType=3",
          name: "品牌企业"
        },
        {
          img: "https://cmscenter-files.nxin.com/nxsc/index/channel/channel-ope.png",
          url: "/channel/shop?shopType=1",
          name: "运营中心"
        },
        {
          img: "https://cmscenter-files.nxin.com/nxsc/index/channel/channel-vip.png",
          url: "/channel/shop/vip",
          name: "养殖会员"
        },
        {
          img: "https://cmscenter-files.nxin.com/nxsc/index/channel/channel-stat.png",
          url: "/channel/shop?shopType=2",
          name: "农信小站"
        }
      ],
      recommend: {
        name: "为您推荐",
        floorList: [
          {
            id: "good",
            name: "优品"
          },
          {
            id: "shop",
            name: "好店"
          }
        ]
      },
      recommendId: "good", // 为你推荐选中的id
      recommendGood: [],
      recommendShop: [],
      floorList: [],
      floorType: "0", // 当前选中的活动楼层类型 0 -- 商品  1 -- 店铺
      cusIndex: 0, // 一级楼层的id
      isShow: false,
      video: {
        // 视频播放相关参数
        url: "",
        cover: "",
        muted: false,
        loop: true,
        preload: "auto",
        poster: "",
        volume: 1,
        autoplay: true
      },
      yyzx: {},
      lat: "",
      lng: "",
      liveList: [] // 直播列表
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    userIdentity: state => state.app.userIdentity
  }),
  created() {
    if (isInZnt()) {
      // 智农通登录
      window.location.href =
        "nxinznt://zhinongtong/p?action=eyJuZWVkTG9naW4iOmZhbHNlLCJwYWdlQ29kZSI6InBhZ2VfYXBwX21haW4iLCJtYWluVGFiIjoibWFsbFRhYiJ9";
    }
    console.log("用户信息userIdentity", this.userIdentity);
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 1000
    });
    this.init();
  },
  methods: {
    init() {
      this.getSwipe();
      this.getHeadline();
      this.getClassify();
      this.getLive();
      this.getRecommend("good");
      this.getRecommend("shop");
      this.getActivity();
      this.getLocation();
      if (this.userInfo.id) {
        this.getCountCart();
        this.getEnterpriseList();
      }
    },

    // 查询购物车数量
    getCountCart() {
      this.$store.dispatch("member/member/getCountCart", this.$qs.stringify({})).then(data => {
        const num = data || 0;
        this.countCart = num > 99 ? "99+" : num;
      });
    },

    // 获取广告轮播图
    getSwipe() {
      const url = "https://graphicinformation.nxin.com/getJsonFormatAdList/16";
      jsonp(url, (err, res) => {
        console.log(err);
        this.swipeList = res || [];
      });
    },

    // 获取商城头条
    getHeadline() {
      this.$store
        .dispatch("index/getHeadline", {
          businessRang: "畜牧首页"
        })
        .then(data => {
          this.headline = data || [];
        });
    },

    // 获取分类导航
    getClassify() {
      this.$store.dispatch("index/getDiamondArea").then(data => {
        this.classify = data || [];
      });
    },

    // 获取直播列表
    getLive() {
      this.$store.dispatch("index/getLiveList").then(data => {
        this.liveList = data || [];
      });
    },
    // 获取运营中心
    getYyzx() {
      const { lat, lng } = this;
      if (!lat || !lng) {
        return;
      }
      this.$store.dispatch("index/getYyzxParam").then(data => {
        let param = data || {};
        param = {
          lat,
          lng,
          ...param
        };
        this.$store.dispatch("index/getYyzxList", param).then(res => {
          const list = res || [];
          let shopList = [];
          list.forEach(item => {
            shopList = shopList.concat(item.shopList);
          });
          shopList = shopList.filter(item => item.indexGoodsList && item.indexGoodsList.length);
          if (!shopList.length) {
            return;
          }
          const yyzxShop = shopList[0];
          const goodList =
            yyzxShop.indexGoodsList.length > 3
              ? yyzxShop.indexGoodsList.slice(0, 3)
              : yyzxShop.indexGoodsList;
          this.yyzx = {
            goodList,
            shopName: yyzxShop.name
          };
          console.log("yyzx", this.yyzx);
        });
      });
    },

    // 获取优品/好店
    getRecommend(type) {
      // 不登录情况
      // 好店
      // open_req_src=zntapi&out_business_type=7&bo_id=0&in_business_id=0&in_business_type=1
      // &use_favorite=1&page=1&use_customer=1&tracking_code=app_znt_haodian_youpin&page_size=12
      // 优品
      // open_req_src=zntapi&use_accurate=1&out_business_type=12&bo_id=0&in_business_id=0&in_business_type=1
      // &order_by=1&use_always_buy=1&page=1&tracking_code=app_znt_haodian_youpin&page_size=12
      const { userIdentity } = this;
      const arg = {
        page: 1,
        page_size: 12,
        order_by: type === "good" ? 1 : 0,
        use_accurate: 1,
        out_business_type: type === "good" ? 12 : 7,
        tracking_code: userIdentity.ID ? "wexin_nxsc_vip_tuijian" : "app_znt_haodian_youpin",
        in_business_id: userIdentity.ID ? userIdentity.ID : 0,
        in_business_type: userIdentity.ID ? userIdentity.Type : 1
      };
      if (!userIdentity.ID) {
        arg.bo_id = 0;
        arg.open_req_src = "zntapi";
        arg.use_accurate = type === "good" ? 1 : "";
        arg.use_always_buy = type === "good" ? 1 : "";
      }
      if (type === "shop") {
        arg.use_customer = 1;
        arg.use_favorite = 1;
      }
      this.$store.dispatch("index/getDsjapiRecommendList", arg).then(data => {
        const list = data || [];
        if (type === "good") {
          list.forEach(item => {
            const price = item.sellFactPriceStr.split(".");
            item.price = price;
          });
          this.recommendGood = list || [];
        } else {
          list.forEach(item => {
            item.shopLevel = Number(item.shopLevel);
          });
          this.recommendShop = list || [];
        }
      });
    },

    // 推荐切换
    recommendChoose(id) {
      this.recommendId = id;
    },

    // 获取活动
    getActivity() {
      this.$store.dispatch("index/getActivityCode").then(res => {
        const activityCode = res;
        if (!res) {
          return;
        }
        this.$store.dispatch("channel/getActivityFloorList", activityCode).then(data => {
          console.log("活动楼层", data);
          if (!data) {
            return;
          }
          //  isExistData：是否展示楼层 0：不展示 1：展示
          const { customPageFloorList } = data;
          this.floorList = customPageFloorList.filter(item => item.isExistData);
          console.log("floorList", this.floorList);
          this.floorList.forEach((item, index) => {
            item.subIndex = 0;
            item.loading = true;
            let floorId = "";
            if (item.subFloorList && item.subFloorList.length) {
              const { id, recommendType } = item.subFloorList[0];
              floorId = id;
              this.floorType = recommendType;
            } else {
              const { id, recommendType } = item;
              floorId = id;
              this.floorType = recommendType;
            }
            this.getGoodList(floorId, index, item.subIndex, this.floorType);
          });
        });
      });
    },

    // 获取楼层商品/店铺
    getGoodList(floorId, cusIndex, subIndex, type) {
      this.$store
        .dispatch("channel/getActivityGoodList", {
          floorId
        })
        .then(res => {
          const { list } = res;
          console.log("商品列表", list);
          const goodList = list || [];
          if (type === "0") {
            goodList.forEach(item => {
              if (item.videoUrl) {
                item.videoCover = `${
                  item.videoUrl
                }?vframe/png/offset/1/h/260/imageMogr2/thumbnail/80000@`;
              }
              const price = item.sellFactPrice ? item.sellFactPriceStr.split(".") : [0, 0];
              item.price = price;
            });
          }
          const floor = this.floorList[cusIndex];
          floor.loading = false;
          if (floor.subFloorList) {
            floor.subFloorList[subIndex].goodList = goodList || [];
          } else {
            floor.goodList = goodList || [];
          }

          this.$set(this.floorList, cusIndex, floor);
        })
        .finally(() => {
          Toast.clear();
        });
    },

    // 切换二级楼层
    chooseSub(item, cusIndex, subIndex) {
      this.cusIndex = cusIndex;
      const floor = this.floorList[cusIndex];
      floor.subIndex = subIndex;
      this.$set(this.floorList, cusIndex, floor);

      const { id, goodList, recommendType } = item;
      this.floorType = recommendType;
      if (goodList) {
        return;
      }
      floor.loading = true;
      this.$set(this.floorList, cusIndex, floor);
      this.getGoodList(id, cusIndex, subIndex, recommendType);
    },

    // 点击跳转
    routerClick(url, type, isLogin) {
      if (!url) {
        return;
      }
      if (isLogin && !common.isLogin(this.userInfo.id)) {
        return;
      }
      if (type === "link") {
        window.location.href = url;
      } else if (type === "hl") {
        window.location.href = `${this.origin.VUE_APP_HL}${url}`;
      } else if (type === "sc") {
        window.location.href = `${this.origin.VUE_APP_APP}${url}`;
      } else {
        this.$router.push(url);
      }
    },

    // 去登录
    toLogin() {
      if (!common.isLogin(this.userInfo.id)) {
        console.log("去登录");
      }
    },

    // 获取企业列表
    getEnterpriseList() {
      this.$store.dispatch("order/confirmOrder/getEnterpriseList").then(res => {
        const { data } = res;
        this.entList = data || [];
        console.log("企业列表", data);
        const { id, image, realName, mobilePhone } = this.userInfo;
        const user = {
          ID: id,
          Name: realName,
          Logo: image,
          isUser: true
        };
        if (this.entList.some(item => item.IsDefault)) {
          this.entList.splice(1, 0, user);
          console.log(user);
        } else {
          this.entList.unshift(user);
        }
        this.entAllList = this.entList;
        console.log("this.entList", this.entList);
        this.defaultEnt = {
          ID: this.entList[0].ID,
          Name: this.entList[0].Name,
          Logo: this.entList[0].Logo,
          phone: mobilePhone,
          isUser: this.entList[0].isUser || false
        };
      });
    },
    // 切换身份
    updateEnterprise(id) {
      if (id === this.defaultEnt.ID) {
        this.chooseEntShow = false;
        return;
      }
      this.$store.dispatch("order/confirmOrder/updateEnterprise", { enterpriseId: id }).then(() => {
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 1000
        });
        this.init();
        this.chooseEntShow = false;
      });
    },
    entListUpdate() {
      let searchEntList = [];
      searchEntList = this.entAllList.filter(item => item.Name.indexOf(this.entSearch) !== -1);
      console.log(searchEntList);
      this.entList = searchEntList;
    },

    getLocation() {
      const that = this;
      if (common.isInWeiXin()) {
        // 微信环境下获取有延迟
        setTimeout(() => {
          wx.getLocation({
            type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success(res) {
              const { latitude, longitude } = res;
              console.log("微信获取经纬度", res);
              that.lat = latitude;
              that.lon = longitude;
              this.getYyzx();
            },
            fail(res) {
              console.log("微信获取经纬度失败", res);
            }
          });
        }, 500);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
